import script from "./GamesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesCard.vue?vue&type=script&setup=true&lang=js"

import "./GamesCard.vue?vue&type=style&index=0&id=5f3019a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3019a0"]])

export default __exports__